module.exports = __webpack_public_path__ + "static/media/learn-more-asset.6164629a.png";